import { Inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Feature } from 'config/feature-flags';
import { Config, CONFIG } from 'config/config';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor(
    @Inject(CONFIG) private readonly config: Config,
    private readonly auth: AuthService,
  ) {}

  public featureEnabled(feature?: Feature): boolean {
    return (
      _.isUndefined(feature) ||
      this.auth.currentOrganization.featureFlags.has(feature) ||
      this.config.featureFlags[feature] ||
      this.auth.userIsAdmin()
    );
  }
}
